import React from 'react'
import { useNavigate,useLocation,Navigate } from 'react-router-dom';
import Menulist from '../components/Menulist';
import MyNewsletterfetch from '../components/FetchOwnNewsletter';


//import Google from './components/Google';
function MyNewsletter() {
  const location = useLocation();
  const navigate = useNavigate();
  const handleCheckChange = (evnt) => {
    if (evnt === 'success')
      console.log(evnt);
   // navigate('/personalize-sections');
  }
  var element = document.getElementById("header-react");
  element.classList.remove("hide");

if (!localStorage.getItem('user-info')) {
    
    return <Navigate to="/" />
  
}else{ return (
    <div className="grid-container">

      <div className="grid-x grid-margin-x my-page">
        <div className="cell large-3">
        <Menulist samircallback={location.pathname}/>
        </div>
        <div className="cell auto">
          <div className="mypage-area">

            <div className="tabs-content" data-tabs-content="profile-tabs">
            <div className="tabs-panel is-active" id="my_newsletter" role="tabpanel" aria-labelledby="my_newsletter-label">
         
                                            <div className="topper-title">
                                                <h3>نشراتك البريدية</h3>
                                                <p>احصل على آخر التحديثات عبر بريدك الإلكتروني  </p>
                                            </div> 
                    
                                            <div className="select-newsletter profile-newsletter margin-top-3"> 
                                                <div className="grid-x grid-margin-x small-up-1 medium-up-2 large-up-3"> 

         
                                                
                            <MyNewsletterfetch/>
                            
                       
                    </div>
                    </div>

                </div>
              
             
            </div>


          </div>
        </div>
      </div>
    </div>
  );

}}

export default MyNewsletter;

